'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCustomerCountry = exports.initCustomerCountry = exports.COUNTRY_CODE_COOKIE_NAME = exports.COUNTRY_CODE_EVENT_NAME = undefined;

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Geolocation service using Maxmind
 *
 * JavaScript library documentation
 * https://dev.maxmind.com/geoip/geolocate-an-ip/client-side-javascript?lang=en
 */

var _window = window,
    geoip2 = _window.geoip2;
var COUNTRY_CODE_EVENT_NAME = exports.COUNTRY_CODE_EVENT_NAME = 'HY::COUNTRY_CODE_SET';
var COUNTRY_CODE_COOKIE_NAME = exports.COUNTRY_CODE_COOKIE_NAME = 'COUNTRY_CODE';

/**
 * Sets the Customer Country of origin to a Cookie that lasts 14 days
 */
var initCustomerCountry = exports.initCustomerCountry = function initCustomerCountry() {
  var countryCode = getCustomerCountry();

  /**
   * Dispatches a document event with the Country Code
   */
  var triggerCountryCodeSet = function triggerCountryCodeSet() {
    var event = new CustomEvent(COUNTRY_CODE_EVENT_NAME, {
      detail: {
        countryCode: countryCode
      }
    });

    document.dispatchEvent(event);
  };

  /**
   * GeoIP2 onSuccess handler
   */
  var onSuccess = function onSuccess(res) {
    countryCode = res.country.iso_code;

    triggerCountryCodeSet();

    _jsCookie2.default.set(COUNTRY_CODE_COOKIE_NAME, countryCode, { expires: 14 });
  };

  /**
   * GeoIP2 onError handler
   */
  var onError = function onError(res) {};

  var options = {};

  if (countryCode) {
    triggerCountryCodeSet();
  } else {
    /**
     * JavaScript library can be blocked by AdBlock or similar extensions
     * so we need to handle the case where the library is not available
     */
    try {
      geoip2.country(onSuccess, onError, options);
    } catch (e) {
      triggerCountryCodeSet();
    }
  }
};

/**
 * Retrieves the Country Code from the Cookie
 *
 * @returns {String} - The Country Code
 */
var getCustomerCountry = exports.getCustomerCountry = function getCustomerCountry() {
  return _jsCookie2.default.get(COUNTRY_CODE_COOKIE_NAME);
};